<template>
  <section>
    <div class="row">
      <div class="col-4 pt-2">
        <div class="row">
          <div class="col-6">
            <button
              class="btn btn-primary btn-sm custom-btn"
              @click="setTargets"
            >
              Edit Targets
            </button>
          </div>
          <div v-if="isAssessment" class="col-6 custom-scale-link">
            <button class="btn btn-link custom-btn" @click="getInstructions">
              Instructions
            </button>
          </div>
        </div>
      </div>
      <div class="col-4 pt-2">
        <div class="row">
          <div v-if="isAssessment" class="d-grid gap-2 col-6 mx-auto">
            <button
              class="btn btn-primary btn-sm custom-btn"
              @click="takeMeasurement"
            >
              Scale Measurement
            </button>
          </div>
          <div class="d-grid gap-2 col-6 mx-auto">
            <button
              class="btn btn-primary btn-sm custom-btn"
              @click="addMeasurement"
            >
              Manual Measurement
            </button>
          </div>
        </div>
      </div>
      <div class="col-4 pt-2"></div>
    </div>
    <div class="row mt-2 mb-2">
      <measurements-two ref="measurements" @saved="savedTargets" />
    </div>
    <div class="row">
      <bodycomp-charts ref="charts" />
    </div>
    <div class="row">
      <bodycomp-measurements ref="bodycompMeasurements" />
    </div>
  </section>
  <measurement-add-dialog
    :show="actionMeasurementAdd"
    @close="closeDialogs"
    @saved="savedMeasurement"
  />
  <targets-dialog
    :show="actionTargets"
    @close="closeDialogs"
    @saved="savedTargets"
  />
  <measurement-take-dialog
    ref="takeMeasurement"
    :show="actionMeasurementTake"
    @close="closeDialogs"
    @saved="savedMeasurement"
  />
  <instructions-dialog :show="actionInstructions" @close="closeDialogs" />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import WeekSelector from '../elements/week-selector'
import Measurements from './progress/bodycomp-measurements'
import MeasurementsTwo from './progress/bodycomp-measurements2'
import BodycompCharts from './progress/bodycomp-charts'
import MeasurementAddDialog from './bodycomp/measurement-add-dialog'
import MeasurementTakeDialog from './bodycomp/measurement-take-dialog'
import TargetsDialog from './bodycomp/targets-dialog'
import BodycompMeasurements from './bodycomp/measurements'
import InstructionsDialog from './assessment/scale/instructions-dialog'
export default {
  name: 'client-bodycomp',
  components: {
    WeekSelector,
    Measurements,
    MeasurementsTwo,
    BodycompCharts,
    MeasurementAddDialog,
    MeasurementTakeDialog,
    TargetsDialog,
    BodycompMeasurements,
    InstructionsDialog,
  },
  data() {
    return {
      actionMeasurementAdd: null,
      actionMeasurementTake: null,
      actionTargets: null,
      actionInstructions: null,
    }
  },
  async mounted() {
    await this.init()
  },
  emits: ['weekChanged', 'changed'],
  computed: {
    ...mapGetters('configuration', ['settings']),
    ...mapGetters('usercardio', ['member', 'summary']),
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      return _data
    },
    week() {
      let _data = ''
      if (this.summary) {
        _data = this.summary.week.name
      }
      return _data
    },
    date() {
      let _data = ''
      if (this.summary) {
        _data = moment(this.summary.week.value).format('YYYY-MM-DD')
      }
      return _data
    },
    isAssessment() {
      let _is = false
      if (this.summary) {
        if (this.summary.organization) {
          if (parseInt(this.summary.organization.assessmentVisibility) === 1) {
            _is = true
          }
        }
      }
      return _is
    },
    instructions() {
      let _data = null
      if (this.settings) {
        this.settings.forEach((element) => {
          if (
            element.Classification === 'Instructions' &&
            element.Name === 'Scale'
          ) {
            if (element.TextValue) {
              let regex = /\n/g
              _data = element.TextValue.replace(regex, '<br/>')
            }
          }
        })
      }
      return _data
    },
  },
  methods: {
    ...mapActions('configuration', ['getSettings']),
    ...mapActions('usercardio', ['getMember']),
    ...mapActions('bodycomposition', ['getBodyComposition']),
    async init() {
      if (this.member === undefined || this.member === null) {
        await this.getMember({
          id: this.member.id,
          date: this.date,
        })
      }
      await this.weekChanged()
      await this.getSettings({
        page: 1,
        pageSize: 999,
        sortBy: 'id',
        orderBy: 'asc',
        search: 'Scale',
        filter: 'Instructions',
      })
    },
    closeDialogs() {
      this.actionMeasurementAdd = null
      this.actionMeasurementTake = null
      this.actionTargets = null
      this.actionInstructions = null
    },
    async changingWeek(week) {
      // await this.weekChanged(week)
      // this.$refs.charts.refreshCharts(30)
      // this.$refs.measurements.refresh()
      // this.$emit('changed')
    },
    async weekChanged(date) {
      console.log('Body Comp Week Changed', {
        week: date,
        summary: this.summary,
      })
      // let data = {
      //   id: this.member.id,
      //   date: moment(this.summary.week.value).format('YYYY-MM-DD'),
      // }
      // TODO: set to today using moment
      let data = {
        id: this.member.id,
        date: moment().format('YYYY-MM-DD'),
      }
      await this.getBodyComposition(data)
      this.$emit('weekChanged', this.summary.week.value)
    },
    getInstructions() {
      this.actionInstructions = {
        instructions: this.instructions,
      }
    },
    setTargets() {
      this.actionTargets = true
    },
    editTargets() {
      this.isEdit = !this.isEdit
    },
    savedTargets() {
      this.actionTargets = null
    },
    addMeasurement() {
      this.actionMeasurementAdd = true
    },
    takeMeasurement() {
      this.actionMeasurementTake = true
      this.$nextTick(() => {
        this.$refs.takeMeasurement.initScale()
      })
    },
    async savedMeasurement() {
      await this.weekChanged()
      this.actionMeasurementAdd = null
      this.actionMeasurementTake = null
      await this.$refs.bodycompMeasurements.search()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  position: relative;
}
.custom-title {
  position: absolute;
  left: 0;
  top: 0;
  button {
    top: -10px;
  }
}
.custom-selector {
  width: 265px;
  margin: 0 auto;
}
.custom-target-actions {
  display: inline-flex;
}
.custom-scale-actions {
  position: relative;
  height: 60px;
}
.custom-btn {
  height: 31px;
}
.custom-scale-link {
  text-align: right;
}
.custom-link {
  position: absolute;
  top: 30px;
}
</style>
